import { QueryObserverResult, useQuery, UseQueryOptions } from '@tanstack/react-query';
import { API_QUERY_KEYS, QueryDefaults } from '../../../api';
import {
  GetIncomingConsultationsRequest,
  GetIncomingConsultationsResponse,
} from '../fragments';
import { getIncomingConsultations } from '../methods';
import { UseIncomingConsultationsTrafficMonitorState } from '../../../store';
import { useRecoilValue, useSetRecoilState } from 'recoil';

export const useIncomingConsultations = (
  options?: UseQueryOptions<GetIncomingConsultationsResponse>
): QueryObserverResult<GetIncomingConsultationsResponse> => {
  const { requestState, pageNumberState } = UseIncomingConsultationsTrafficMonitorState();
  const setPageNumberState = useSetRecoilState(pageNumberState);
  const stateValue = useRecoilValue(requestState);
  const request = { ...stateValue } as unknown as GetIncomingConsultationsRequest;

  return useQuery<GetIncomingConsultationsResponse>(
    [API_QUERY_KEYS.getIncomingConsultations, request],
    () => getIncomingConsultations(request),
    {
      ...QueryDefaults,
      ...options,
      onSuccess: (data: GetIncomingConsultationsResponse) => {
        if (
          data?.paginationInfo?.totalCount > 0 &&
          data?.incomingConsultations.items.length === 0
        ) {
          setPageNumberState(1);
        }
      },
      onError: (err: unknown) => ({
        err,
      }),
    }
  );
};
